<div class="driver-card col-12 text-center" [class.selected]="(driverIdSelected$ | async) === driver.id" (click)="onClick()">
  
  <div class="driver-info">
    <div class="d-flex flex-column gap-0 justify-content-start align-items-start">
      <!-- <i class="fas fa-video"></i> -->
      <span class="driver-name"></span>
    </div>
    <div class="d-flex flex-row gap-2 driver-document justify-content-center align-items-center">
      <i class="fas fa-user-circle" *ngIf="driver.fromEvent" [pTooltip]="'Del evento'" tooltipPosition="top"></i>
      <i class="fas fa-check" *ngIf="driver.withChecklist" [pTooltip]="'Checklist'" tooltipPosition="top"></i>
      <i class="fas fa-user-cog" *ngIf="driver.enrolled" [pTooltip]="'Enrolado'" tooltipPosition="top"></i>
      <i class="fas fa-user-check" *ngIf="driver.evaluated" [pTooltip]="driver.frequency ? ('Evaluado (' + driver.frequency + ')') : 'Evaluado'" tooltipPosition="top"></i>
    </div>
  </div>
  <div class="driver-image-wrapper">
    <img
      [src]="driver.image"
      [alt]="driver.name"
    />
    <div class="driver-details">
      <!-- <i class="far fa-images"></i>
      <i class="fas fa-check-double"></i> -->
    </div>
  </div>

  <div class="driver-info">
    <div class="d-flex flex-column gap-0 justify-content-start align-items-start">
      <!-- <i class="fas fa-video"></i> -->
      <span class="driver-name">{{driver.name}}</span>
    </div>
    <div class="d-flex flex-row gap-2 driver-document justify-content-center align-items-center">
      <span class="driver-checklistdate">{{ displayDate }}</span>
    </div>
  </div>
</div>
